// Module
var code = `<div class="condition" ng-if="\$ctrl.exists">
  <div class="flex-container">
    <div class="transcluded" ng-transclude>
    </div>

    <div class="close" ng-click="\$ctrl.close()"></div>
  </div>
</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/compliance/risk-profiling/conditions/condition.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;